import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { releaseReservations } from '../../services/reservationsService'

export default function ReleaseReservationsDialog({
  onRelease,
  reservationData,
  isChecked,
  checkedRanIds,
  ...overlay
}) {
  const { t } = useTranslation()

  const { error } = useNotifications()

  if (!reservationData || !reservationData.reservations || reservationData.reservations.length < 1) {
    return null
  }

  const anyPrinted = () => {
    const printedRanIds = reservationData.reservations
      .filter((res) => res.printedDate && res.printedDate !== '')
      .map((res) => res.encodedRanId)
    return printedRanIds.some((printedRanId) => isChecked(printedRanId))
  }

  const handleReleaseReservations = () => {
    releaseReservations(checkedRanIds)
      .then(() => {
        onRelease()
      })
      .catch((err) => {
        error(
          t('reservation.errors.releasingReservations', {
            defaultValue: `Error releasing reservations: ${err.message || ''}`,
            message: err.message,
          }),
          err
        )
      })
  }

  return (
    <DialogOverlay
      {...overlay}
      confirm={t('action.release', 'Release')}
      onConfirm={handleReleaseReservations}
      dismiss={t('action.cancel', 'Cancel')}
      title={t('reservations.releaseReservations', 'Release Reservations')}
    >
      {anyPrinted() && (
        <div>
          {t(
            'warning.releasingPrintedReservations',
            'Warning: You have selected at least one reservation that has already been printed. Releasing printed reservations could result in duplicate ordinances being performed.'
          )}
        </div>
      )}
      <div>{t('reservations.releaseConfirmation', 'Are you sure you want to release these reservations?')}</div>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="Confirm Release Reservations" emphasis="high" onClick={handleReleaseReservations}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
